import { useMutation } from "@tanstack/react-query";
import { topicUpdate } from "common/api/asocijator/topic/asocijator_topic";
import useTopicWork from "common/topic/provider/TopicWork";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseTopicUpdateParams = {
  invalidateKeys?: string[];
  invalidateKeysArray?: string[][];
};

export const useTopicUpdate = (hookParams?: UseTopicUpdateParams) => {
  const { topicWork, topicWorkSet } = useTopicWork();

  const { invalidateQueriesByKeys, invalidateQueriesArraysByKeys } =
    useInvalidateQueryByKeys();
  const { mutate: topicUpdateMutate } = useMutation({
    mutationFn: async (params: any) =>
      await topicUpdate(params.id, params.updatePayload),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      } else if (hookParams?.invalidateKeysArray) {
        invalidateQueriesArraysByKeys(hookParams.invalidateKeysArray);
      }

      if (topicWork && topicWork.id && topicWork.id === "idTopicUpdated") {
        // TODO: pronaci kako da se prepozna koji je id update-ovanog topic-a
        // U slucaju da je isti kao topicWork.id, pokrece se preuzimanje topic-a iz baze i azuriranje topciWork u localStorage
      }
    },
  });

  return { topicUpdateMutate };
};
